import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from './baseQuery';

export const authApi = createApi({
  baseQuery: customBaseQuery,
  reducerPath: 'authApi',
  tagTypes: ['Auth'],
  endpoints: (builder) => ({
    oAuth: builder.mutation({
      query: (params) => ({
        url: 'oauth/token',
        method: 'POST',
        body: {
          ...params,
          grant_type: 'password',
          account_type: 'User'
        }
      })
    }),
    sendEmail: builder.mutation({
      query: (params) => ({
        url: 'reset_passwords',
        method: 'POST',
        params: params
      })
    }),
    resetPassword: builder.mutation({
      query: (payload) => ({
        url: 'reset_passwords',
        method: 'PUT',
        params: payload.params,
        body: payload.body
      })
    }),
    sendCode: builder.mutation({
      query: (body) => ({
        url: 'auth/confirm_code',
        method: 'POST',
        body,
      }),
    }),
    sendCodePhone: builder.mutation({
      query: (body) => ({
        url: 'auth/confirm_code_phone',
        method: 'POST',
        body,
      }),
    }),
    authLogin: builder.mutation({
      query: (body) => ({
        url: 'auth/verify',
        method: 'POST',
        body,
      }),
    }),
    user: builder.query({
      query: () => ({
        url: 'user',
        method: 'GET',
      })
    }),
    updateUser: builder.mutation({
      query: (body) => ({
        url: 'user',
        method: 'PUT',
        body: body?.user !== undefined ? body : { user: body },
      })
    }),
    changePassword: builder.mutation({
      query: (body) => ({
        url: 'passwords',
        method: 'PUT',
        body
      })
    }),
    updateStatusNotification: builder.mutation({
      query: (lastNotificationId) => ({
        url: '/user/update_status_notification',
        method: 'POST',
        body: { last_notification_id: lastNotificationId },
      })
    }),
    getLatestCompanyNotification: builder.query({
      query: () => ({
        url: '/user/latest_company_notification',
        method: 'GET',
      })
    }),
    getShowViewTime: builder.query({
      query: ({ params }) => ({
        url: 'user/show_view_time',
        method: 'GET',
        params
      })
    }),
  }),
  
});

export const { 
  useGetShowViewTimeQuery,
  useSendCodeMutation,
  useAuthLoginMutation,
  useSendCodePhoneMutation,
  usePrefetch,
  useUserQuery,
  useUpdateUserMutation,
  useLazyUserQuery,
  useOAuthMutation,
  useSendEmailMutation,
  useResetPasswordMutation,
  useChangePasswordMutation,
  useUpdateStatusNotificationMutation,
  useGetLatestCompanyNotificationQuery,
} = authApi;
